import React from "react";
import IconAlertTriangleLinear from "@/assets/icons/alert-triangle-linear.svg?react";
import IconChevron from "@/assets/icons/chevron.svg?react";

interface Props {
  text: string;
  className?: string;
  icon?: React.ReactNode;
  noLink?: boolean;
  onClick?: () => void;
}

const CommonInfoLink = ({
  text,
  className,
  noLink = false,
  icon = (
    <IconAlertTriangleLinear className="shrink-0" width="20" height="20" />
  ),
}: Props) => {
  return (
    <div
      className={`${className} px-3 py-2 rounded-xl backdrop-blur-[10px] bg-[linear-gradient(83deg,rgba(251,199,108,0.10)_-31.43%,rgba(235,161,50,0.10)_100%)] flex-y-center`}
    >
      <div className="flex items-center">
        {icon}
        <p className="text-xs text-white leading-130 font-normal ml-3 mr-2.5">
          {text}
        </p>
      </div>
      {!noLink && <IconChevron className="shrink-0" width="20" height="20" />}
    </div>
  );
};

export default CommonInfoLink;
